"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactStripeJs = require("@stripe/react-stripe-js");

var _Box = _interopRequireDefault(require("../../Box/Box"));

var _Text = _interopRequireDefault(require("../../Text/Text"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* eslint-disable jsx-a11y/label-has-associated-control */

/* eslint-disable react/jsx-props-no-spreading */
var PlaceholderInput = _styledComponents["default"].input.withConfig({
  displayName: "CardDetails__PlaceholderInput",
  componentId: "sc-1l0wrwh-0"
})(["font-size:16px;border:none;background-color:transparent;width:100%;padding-bottom:8px;"]);

var CardInputBox = (0, _styledComponents["default"])(_Box["default"]).withConfig({
  displayName: "CardDetails__CardInputBox",
  componentId: "sc-1l0wrwh-1"
})(["position:relative;margin-top:8px;background-color:", ";border-bottom:", ";padding:", ";border-radius:4px 4px 0 0;transition:0.15s;:hover{background-color:", ";border-bottom:", ";}label{color:", ";font-family:", ";left:16px;right:auto;top:18px;pointer-events:none;position:absolute;line-height:1.15rem;transition:0.15s;transform:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.dark[7];
}, function (_ref2) {
  var theme = _ref2.theme,
      isTouched = _ref2.isTouched,
      hasError = _ref2.hasError;

  if (hasError) {
    return "2px solid " + theme.colors.error[0];
  }

  if (isTouched) {
    return "2px solid " + theme.colors.primary[0];
  }

  return "1px solid " + theme.colors.dark[3];
}, function (_ref3) {
  var isTouched = _ref3.isTouched;
  return isTouched ? "27px 16px 6px" : "20px 16px 6px";
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.dark[6];
}, function (_ref5) {
  var theme = _ref5.theme,
      isTouched = _ref5.isTouched;
  return isTouched ? "2px solid " + theme.colors.primary[0] : "1px solid " + theme.colors.dark[1];
}, function (_ref6) {
  var theme = _ref6.theme,
      isTouched = _ref6.isTouched,
      hasError = _ref6.hasError;

  if (hasError) {
    return theme.colors.error[0];
  }

  if (isTouched) {
    return theme.colors.primary[0];
  }

  return theme.colors.dark[2];
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.fonts.sansSerif;
}, function (_ref8) {
  var isTouched = _ref8.isTouched;
  return isTouched ? "translateY(-50%) translateX(-15%) scale(0.75)" : "none";
});
var style = {
  style: {
    base: {
      fontSize: "16px",
      color: "rgba(0,0,0,0.87)",
      "::placeholder": {
        color: "rgba(0,0,0,0.6)"
      }
    },
    invalid: {
      color: "rgba(191,70,48,1)"
    }
  }
};

var CardDetails = function CardDetails(_ref9) {
  var onChange = _ref9.onChange;

  var _useState = (0, _react.useState)(false),
      isTouched = _useState[0],
      setIsTouched = _useState[1];

  var _useState2 = (0, _react.useState)(null),
      error = _useState2[0],
      setError = _useState2[1];

  var handleChange = function handleChange(e) {
    setError(e.error);
    onChange(e);
  };

  return /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    onClick: function onClick() {
      return setIsTouched(true);
    },
    onFocus: function onFocus() {
      return setIsTouched(true);
    }
  }, /*#__PURE__*/_react["default"].createElement(CardInputBox, {
    isTouched: isTouched,
    hasError: !!error
  }, /*#__PURE__*/_react["default"].createElement("label", null, "Card details"), isTouched ? /*#__PURE__*/_react["default"].createElement(_reactStripeJs.CardElement, (0, _extends2["default"])({
    hidePostalCode: true,
    onChange: handleChange,
    onReady: function onReady(el) {
      return el.focus();
    }
  }, style)) : /*#__PURE__*/_react["default"].createElement(PlaceholderInput, {
    type: "text"
  })), /*#__PURE__*/_react["default"].createElement(_Box["default"], null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    fontSize: 2,
    color: "error.0"
  }, error && error.message)));
};

var _default = CardDetails;
exports["default"] = _default;